/* Thème « Linge de bain – sur mesure » — JS léger, sans dépendance. */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {};

  /* ---------------- Utilitaires ---------------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function fetchSection(sectionId, url) {
    var base = url || routes.root || '/';
    var sep = base.indexOf('?') > -1 ? '&' : '?';
    return fetch(base + sep + 'section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc;
      });
  }

  /* ---------------- Panier (tiroir) ---------------- */
  var CartDrawer = {
    el: null,
    overlay: null,
    init: function () {
      this.el = qs('[data-cart-drawer]');
      this.overlay = qs('[data-cart-overlay]');
      if (!this.el) return;
      var self = this;
      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-cart-open]');
        if (opener && !document.body.classList.contains('template-cart')) {
          e.preventDefault();
          self.open();
        }
        if (e.target.closest('[data-cart-close]')) { e.preventDefault(); self.close(); }
      });
      if (this.overlay) this.overlay.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
      this.bindLines();
    },
    open: function () {
      if (!this.el) return;
      this.el.removeAttribute('hidden');
      if (this.overlay) this.overlay.removeAttribute('hidden');
      var self = this;
      requestAnimationFrame(function () {
        self.el.classList.add('is-open');
        if (self.overlay) self.overlay.classList.add('is-open');
      });
      document.body.style.overflow = 'hidden';
      this.el.setAttribute('aria-hidden', 'false');
      var closeBtn = qs('[data-cart-close]', this.el);
      if (closeBtn) closeBtn.focus();
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      this.el.setAttribute('aria-hidden', 'true');
      var self = this;
      setTimeout(function () {
        self.el.setAttribute('hidden', '');
        if (self.overlay) self.overlay.setAttribute('hidden', '');
      }, 350);
    },
    refresh: function () {
      var self = this;
      return fetchSection('cart-drawer', routes.cart).then(function (doc) {
        var fresh = doc.querySelector('[data-cart-drawer]');
        if (fresh && self.el) {
          self.el.innerHTML = fresh.innerHTML;
          self.bindLines();
        }
        var freshCount = doc.querySelector('[data-cart-count-source]');
        if (freshCount) self.setCount(freshCount.getAttribute('data-cart-count-source'));
      });
    },
    setCount: function (n) {
      qsa('[data-cart-count]').forEach(function (b) {
        b.textContent = n;
        b.setAttribute('data-count', n);
      });
    },
    bindLines: function () {
      var self = this;
      if (!this.el) return;
      qsa('[data-line-change]', this.el).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = btn.getAttribute('data-line');
          var input = qs('input[data-line-qty][data-line="' + line + '"]', self.el);
          var current = input ? parseInt(input.value, 10) || 0 : 0;
          var delta = parseInt(btn.getAttribute('data-line-change'), 10);
          self.change(line, Math.max(0, current + delta));
        });
      });
      qsa('input[data-line-qty]', this.el).forEach(function (input) {
        input.addEventListener('change', function () {
          self.change(input.getAttribute('data-line'), Math.max(0, parseInt(input.value, 10) || 0));
        });
      });
      qsa('[data-line-remove]', this.el).forEach(function (btn) {
        btn.addEventListener('click', function () { self.change(btn.getAttribute('data-line'), 0); });
      });
    },
    change: function (line, quantity) {
      var self = this;
      this.el.classList.add('is-loading');
      return fetch(routes.cartChange, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function () { return self.refresh(); })
        .then(function () { self.el.classList.remove('is-loading'); })
        .catch(function () { self.el.classList.remove('is-loading'); });
    },
    add: function (formData) {
      var self = this;
      return fetch(routes.cartAdd, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
        body: formData
      }).then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
        .then(function (res) {
          if (!res.ok) { throw new Error(res.json && (res.json.description || res.json.message) || strings.cartError); }
          return self.refresh();
        });
    }
  };

  window.DVCart = CartDrawer;

  /* ---------------- Fiche produit ---------------- */
  function ProductForm(root) {
    this.root = root;
    this.form = qs('form[data-product-form]', root);
    if (!this.form) return;
    this.idInput = qs('input[name="id"]', this.form);
    this.button = qs('[data-add-button]', this.form);
    this.buttonText = qs('[data-add-button-text]', this.form);
    this.status = qs('[data-form-status]', root);
    this.priceEl = qs('[data-product-price]', root);
    this.compareEl = qs('[data-product-compare]', root);
    this.badgeEl = qs('[data-product-badge]', root);
    try { this.variants = JSON.parse(qs('[data-variants]', root).textContent); } catch (e) { this.variants = []; }
    this.optionGroups = qsa('[data-option-index]', root);
    var self = this;
    this.optionGroups.forEach(function (group) {
      group.addEventListener('change', function () { self.onChange(); });
    });
    this.form.addEventListener('submit', function (e) { self.onSubmit(e); });
    this.updateAvailability();
    qsa('[data-media-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () { self.scrollToMedia(t.getAttribute('data-media-thumb')); });
    });
  }

  ProductForm.prototype.selectedOptions = function () {
    return this.optionGroups.map(function (group) {
      var checked = qs('input:checked', group);
      if (checked) return checked.value;
      var select = qs('select', group);
      return select ? select.value : null;
    });
  };

  ProductForm.prototype.findVariant = function (options) {
    return this.variants.filter(function (v) {
      return v.options.every(function (opt, i) { return opt === options[i]; });
    })[0] || null;
  };

  ProductForm.prototype.onChange = function () {
    var options = this.selectedOptions();
    var variant = this.findVariant(options);
    this.optionGroups.forEach(function (group) {
      var checked = qs('input:checked', group);
      var label = qs('[data-option-selected]', group);
      if (checked && label) label.textContent = checked.value;
    });
    this.updateAvailability();
    if (!variant) {
      this.setButton(false, strings.unavailable);
      return;
    }
    this.idInput.value = variant.id;
    if (this.priceEl) this.priceEl.textContent = variant.price;
    if (this.compareEl) {
      if (variant.compare) { this.compareEl.textContent = variant.compare; this.compareEl.removeAttribute('hidden'); }
      else { this.compareEl.setAttribute('hidden', ''); }
    }
    if (this.badgeEl) { if (variant.compare) { this.badgeEl.removeAttribute('hidden'); var sv = qs('[data-product-saving]', this.badgeEl); if (sv && variant.saving) sv.textContent = variant.saving; } else this.badgeEl.setAttribute('hidden', ''); }
    this.setButton(variant.available, variant.available ? strings.addToCart : strings.soldOut);
    if (variant.mediaId) this.scrollToMedia(variant.mediaId);
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  };

  ProductForm.prototype.setButton = function (enabled, text) {
    if (!this.button) return;
    if (enabled) this.button.removeAttribute('disabled'); else this.button.setAttribute('disabled', '');
    if (this.buttonText && text) this.buttonText.textContent = text;
  };

  /* Marque les valeurs sans variante disponible, compte tenu des autres choix. */
  ProductForm.prototype.updateAvailability = function () {
    var selected = this.selectedOptions();
    var variants = this.variants;
    this.optionGroups.forEach(function (group, index) {
      qsa('input', group).forEach(function (input) {
        var candidate = selected.slice();
        candidate[index] = input.value;
        var exists = variants.some(function (v) {
          return v.available && v.options.every(function (opt, i) { return i === index ? opt === input.value : (candidate[i] === null || opt === candidate[i]); });
        });
        var visual = input.nextElementSibling;
        if (visual) visual.classList.toggle('is-unavailable', !exists);
      });
    });
  };

  ProductForm.prototype.scrollToMedia = function (mediaId) {
    var item = qs('[data-media-id="' + mediaId + '"]', this.root);
    if (!item) return;
    var container = item.parentElement;
    /* La photo du coloris choisi passe en premier. */
    if (container.firstElementChild !== item) container.insertBefore(item, container.firstElementChild);
    if (window.matchMedia('(max-width: 989px)').matches) {
      container.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      var top = container.getBoundingClientRect().top + window.pageYOffset - 110;
      if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }
  };

  ProductForm.prototype.onSubmit = function (e) {
    e.preventDefault();
    var self = this;
    if (this.button && this.button.hasAttribute('disabled')) return;
    var original = this.buttonText ? this.buttonText.textContent : '';
    this.button.setAttribute('aria-busy', 'true');
    if (this.buttonText) this.buttonText.textContent = '…';
    if (this.status) { this.status.textContent = ''; this.status.classList.remove('is-success'); }
    var data = new FormData(this.form);
    data.delete('sections');
    /* Pack : on ajoute les articles réels pour que la remise par quantité s'applique sur tout le panier */
    var packEl = qs('[data-pack-components]', this.root);
    if (packEl) {
      var comps = JSON.parse(packEl.textContent || '{}')[String(data.get('id'))];
      if (comps && comps.length) {
        var times = parseInt(data.get('quantity'), 10) || 1;
        var packName = packEl.getAttribute('data-pack-title');
        var extra = [];
        data.forEach(function (v, k) {
          var m = k.match(/^properties\[(.+)\]$/);
          if (m && String(v).trim()) extra.push([m[1], String(v).trim()]);
        });
        data = new FormData();
        comps.forEach(function (c, i) {
          data.append('items[' + i + '][id]', c[0]);
          data.append('items[' + i + '][quantity]', c[1] * times);
          data.append('items[' + i + '][properties][Pack]', packName);
          extra.forEach(function (x) { data.append('items[' + i + '][properties][' + x[0] + ']', x[1]); });
        });
      }
    }
    Array.prototype.slice.call(data.keys()).forEach(function (key) {
      if (key.indexOf('option-') === 0) data.delete(key);
    });
    CartDrawer.add(data).then(function () {
      self.button.removeAttribute('aria-busy');
      if (self.buttonText) self.buttonText.textContent = original;
      CartDrawer.open();
    }).catch(function (err) {
      self.button.removeAttribute('aria-busy');
      if (self.buttonText) self.buttonText.textContent = original;
      if (self.status) self.status.textContent = err.message || strings.cartError;
    });
  };

  /* ---------------- Quantité (+ / −) ---------------- */
  function initQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      var wrap = btn.closest('.qty');
      var input = wrap && qs('input', wrap);
      if (!input) return;
      var min = parseInt(input.getAttribute('min'), 10) || 1;
      var next = (parseInt(input.value, 10) || min) + parseInt(btn.getAttribute('data-qty-change'), 10);
      input.value = Math.max(min, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------------- Tri collection ---------------- */
  function initSort() {
    qsa('[data-sort-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------------- Menu mobile ---------------- */
  function initMenu() {
    qsa('details.menu-drawer').forEach(function (d) {
      d.addEventListener('toggle', function () { document.body.style.overflow = d.open ? 'hidden' : ''; });
      qsa('[data-menu-close]', d).forEach(function (b) { b.addEventListener('click', function () { d.removeAttribute('open'); }); });
    });
  }

  /* ---------------- Pastilles coloris sur les cartes ---------------- */
  function initCardSwatches() {
    document.addEventListener('click', function (e) {
      var dot = e.target.closest('.card .swatch-dot');
      if (!dot) return;
      e.preventDefault();
      var card = dot.closest('.card');
      qsa('.swatch-dot', card).forEach(function (d) { d.classList.toggle('is-active', d === dot); });
      var img = qs('.card__img--main', card);
      var src = dot.getAttribute('data-swatch-img');
      if (img && src) {
        img.removeAttribute('srcset');
        img.src = src;
        img.alt = dot.getAttribute('data-swatch-alt') || img.alt;
        card.classList.add('has-swatch');
      }
      var url = dot.getAttribute('data-swatch-url');
      if (url) qsa('a[href]', card).forEach(function (a) { a.href = url; });
    });
  }

  /* ---------------- Démarrage ---------------- */
  document.addEventListener('DOMContentLoaded', function () {
    CartDrawer.init();
    qsa('[data-product]').forEach(function (root) { new ProductForm(root); });
    initQuantity();
    initSort();
    initMenu();
    initCardSwatches();
  });

  window.themeCart = CartDrawer;
})();
